import React, { useEffect, useState } from "react";
import "./HalfList.scss";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";

const HalfList = ({
  data,
  fields,
  setSelectedItem,
  isAddModalOpen,
  elem,
  can_create,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!isAddModalOpen) {
      setIsAddOpen(false);
    }
  }, [isAddModalOpen]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getFormattedValue = (item, field) => {
    if (item[field] === null || item[field] === undefined) return "-";

    // Check if it's a date string (simple check)
    if (
      typeof item[field] === "string" &&
      item[field].match(/^\d{4}-\d{2}-\d{2}/)
    ) {
      return new Date(item[field]).toLocaleDateString();
    }

    return item[field].toString();
  };

  // Filter data based on search term
  let filteredData = searchTerm
    ? data.filter((item) =>
        fields.some(
          (field) =>
            item[field] &&
            item[field]
              .toString()
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
        )
      )
    : data;

  // Sort data if sortConfig is set
  if (sortConfig.key) {
    filteredData = [...filteredData].sort((a, b) => {
      if (a[sortConfig.key] === null) return 1;
      if (b[sortConfig.key] === null) return -1;

      const aValue = a[sortConfig.key].toString().toLowerCase();
      const bValue = b[sortConfig.key].toString().toLowerCase();

      if (aValue < bValue) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  }

  return (
    <div className="halflist">
      <Modal isOpen={isAddOpen} onClose={() => setIsAddOpen(false)}>
        {elem}
      </Modal>

      <div className="halflist-header">
        <div className="halflist-header-search">
          <div className="search-input-container">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <span className="search-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </span>
          </div>
        </div>

        {can_create && (
          <div className="halflist-header-add">
            <Button
              type={`curvedSmall`}
              text={`Add New`}
              onClick={() => {
                window.scrollTo(0, 0);
                setIsAddOpen(true);
              }}
            />
          </div>
        )}
      </div>

      <div className="list-section">
        <div className="table-container">
          <table>
            <thead>
              <tr className="list-section-rowHead">
                {fields.map((field) => (
                  <th key={field} onClick={() => requestSort(field)}>
                    <div className="th-content">
                      <span>{field.replace(/_/g, " ").toUpperCase()}</span>
                      {sortConfig.key === field && (
                        <span className={`sort-icon ${sortConfig.direction}`}>
                          {sortConfig.direction === "ascending" ? "↑" : "↓"}
                        </span>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr
                    key={item.id}
                    onClick={() => {
                      setSelectedItem(item);
                      setSelectedId(item.id);
                    }}
                    className={selectedId === item.id ? "selected" : ""}
                  >
                    {fields.map((field) => (
                      <td key={field}>{getFormattedValue(item, field)}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr className="no-data-row">
                  <td colSpan={fields.length}>No matching records found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="halflist-footer">
        <div className="record-count">
          <span className="count-number">{filteredData.length}</span> records
          found
        </div>
      </div>
    </div>
  );
};

export default HalfList;
